import 'babel-polyfill';
import "./utils/px2rem"
import 'lib-flexible'
import 'bootstrap/dist/css/bootstrap.min.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../src/assets/global.css'
import '../public/fonts/font.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
